var _mask, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconComment = function SvgIconComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon_comment_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 0A1.5 1.5 0 0 0 0 1.5v9.799a.7.7 0 0 0 1.119.561l1.836-1.37H10.5a1.5 1.5 0 0 0 1.5-1.5V1.5A1.5 1.5 0 0 0 10.5 0h-9Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 8.252-.394.919L1 9.768V8.252H0Zm0 0 .394-.92L-1 6.736v1.516h1Zm1.119 3.608.598.802-.598-.802Zm1.836-1.37v-1h-.332l-.266.198.598.802ZM1 1.5a.5.5 0 0 1 .5-.5v-2A2.5 2.5 0 0 0-1 1.5h2Zm0 6.752V1.5h-2v6.752h2Zm-1.394.919.788-1.839-.788 1.839ZM1 11.299V8.252h-2v3.047h2Zm-.48-.24a.3.3 0 0 1 .48.24h-2c0 1.4 1.595 2.2 2.717 1.363L.52 11.059Zm1.837-1.37-1.836 1.37 1.196 1.603 1.836-1.37-1.196-1.604Zm8.143-.2H2.955v2H10.5v-2Zm.5-.5a.5.5 0 0 1-.5.5v2a2.5 2.5 0 0 0 2.5-2.5h-2ZM11 1.5v7.49h2V1.5h-2Zm-.5-.5a.5.5 0 0 1 .5.5h2A2.5 2.5 0 0 0 10.5-1v2Zm-9 0h9v-2h-9v2Z",
    fill: "#000",
    fillOpacity: 0.25,
    mask: "url(#icon_comment_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.182 6.493c0-.275.248-.498.555-.498h4.596c.306 0 .555.223.555.498s-.249.498-.555.498H3.737c-.307 0-.555-.223-.555-.498ZM3.182 4.004c0-.275.248-.498.555-.498h4.596c.306 0 .555.223.555.498s-.249.497-.555.497H3.737c-.307 0-.555-.222-.555-.497Z",
    fill: "#000",
    fillOpacity: 0.25
  })));
};
export default SvgIconComment;